import script from "./PointingView.vue?vue&type=script&lang=ts&setup=true"
export * from "./PointingView.vue?vue&type=script&lang=ts&setup=true"

import "./PointingView.vue?vue&type=style&index=0&id=dbbdb526&lang=scss"

const __exports__ = script;

export default __exports__